<script setup lang="ts">
import LanguageContent from './components/LanguageContent.vue'

definePage({
  name: '/settings/Language',
  path: '/instellingen/taal',
  meta: {
    layout: 'false',
  },
})
</script>

<template>
  <LanguageContent />
</template>
